import { APIStatus } from '@application/common/enums/api-status';
import { createSlice } from '@reduxjs/toolkit';
import { getUsersAsync, getUserByIdAsync, updateUserAsync, disableUserAsync, enableUserAsync, getUserByStatusAsync, getUserByEmailAsync, getCurrentUserAsync } from './adminUserThunk';
import { UserStatus, UserStatusMap } from '@application/common/enums/user-status';
const initialState = {
    status: APIStatus.IDLE,
    userDetailsModalOpen: false,
    userInvoicesModalOpen: false,
    userDebtorsModalOpen: false,
    userOutStandingBalanceModalOpen: false,
    filteredUsers: [],
    searchTerm: '',
    getUserDetailsRequest: {
        pageNumber: 1,
        pageSize: 10000
    },
    getUserInvoiceRequest: {
        pageNumber: 1,
        pageSize: 10000
    },
    userStatuses: [
        { label: UserStatusMap.get(UserStatus.Pending), value: UserStatus.Pending.toString() },
        { label: UserStatusMap.get(UserStatus.Approved), value: UserStatus.Approved.toString() }
    ],
    disableUserConfirmOpen: false,
    enableUserConfirmOpen: false,
    newOrDeclinedUsers: []
};
export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        toggleUserDetailsModal(state) {
            state.user = state.userDetailsModalOpen ? undefined : state.user;
            state.userDetailsModalOpen = !state.userDetailsModalOpen;
        },
        toggleUserInvoicesModal(state) {
            if (state.userInvoicesModalOpen) {
                // state.userInvoices = undefined;
                state.getUserInvoiceRequest = {
                    pageNumber: 1,
                    pageSize: 10000,
                    filter: ''
                };
            }
            state.userInvoicesModalOpen = !state.userInvoicesModalOpen;
        },
        toggleUserDebtorsModal(state) {
            //state.userDebtors = state.userDebtorsModalOpen ? [] : state.userDebtors;
            state.userDebtorsModalOpen = !state.userDebtorsModalOpen;
        },
        toggleUserOutStandingBalanceModal(state) {
            state.balance = state.userOutStandingBalanceModalOpen ? undefined : state.balance;
            state.userOutStandingBalanceModalOpen = !state.userOutStandingBalanceModalOpen;
        },
        setUserDetailsRequest(state, action) {
            state.getUserDetailsRequest = action.payload;
        },
        setUserInvoicesRequest(state, action) {
            state.getUserInvoiceRequest = action.payload;
        },
        setSelectedStatus(state, action) {
            state.selectedStatus = action.payload;
        },
        toggleDisableUserConfirm(state) {
            state.disableUserConfirmOpen = !state.disableUserConfirmOpen;
        },
        toggleEnableUserConfirm(state) {
            state.enableUserConfirmOpen = !state.enableUserConfirmOpen;
        },
        resetUsers(state) {
            state.users = undefined;
            state.getUserDetailsRequest = {
                pageNumber: 1,
                pageSize: 10000,
                filter: ''
            };
        },
        resetFreelancerBalance(state) {
            state.balance = undefined;
        },
        resetUserDetails(state) {
            state.user = undefined;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getUsersAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getUsersAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.users = action.payload;
        })
            .addCase(getUsersAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getUserByStatusAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getUserByStatusAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.newOrDeclinedUsers = action.payload;
        })
            .addCase(getUserByStatusAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getUserByIdAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getUserByIdAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.user = action.payload;
        })
            .addCase(getUserByIdAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getCurrentUserAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getCurrentUserAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.currentUser = action.payload;
        })
            .addCase(getCurrentUserAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(updateUserAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(updateUserAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.user = action.payload;
            state.userDetailsModalOpen = false;
        })
            .addCase(updateUserAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(disableUserAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(disableUserAsync.fulfilled, (state) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(disableUserAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(enableUserAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(enableUserAsync.fulfilled, (state) => {
            state.status = APIStatus.IDLE;
        })
            .addCase(enableUserAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
        builder
            .addCase(getUserByEmailAsync.pending, (state) => {
            state.status = APIStatus.PENDING;
            state.apiError = undefined;
        })
            .addCase(getUserByEmailAsync.fulfilled, (state, action) => {
            state.status = APIStatus.IDLE;
            state.user = action.payload;
        })
            .addCase(getUserByEmailAsync.rejected, (state, action) => {
            state.status = APIStatus.FAILED;
            state.apiError = action.payload;
        });
    }
});
export const { toggleUserDetailsModal, setUserDetailsRequest, setSelectedStatus, toggleUserInvoicesModal, toggleUserDebtorsModal, toggleUserOutStandingBalanceModal, setUserInvoicesRequest, toggleDisableUserConfirm, resetUserDetails, toggleEnableUserConfirm, resetUsers, resetFreelancerBalance } = userSlice.actions;
export default userSlice.reducer;
